/**
 * DOMに関する共通関数を記載
 */
const insertSafeAreaTop = () => {
  // ノッチの高さ参照用のdivタグを追加
  const safeAreaTopHeightElement = document.createElement("div");
  safeAreaTopHeightElement.id = "safe-area-top-height";
  safeAreaTopHeightElement.style.height = "env(safe-area-inset-top)";
  // DOM追加
  document.body.appendChild(safeAreaTopHeightElement);
};

/**
 * insertSafeAreaTop()で設定したノッチの高さを取得
 */
export const getSafeAreaTop = (): number => {
  insertSafeAreaTop();
  const safeAreaTopHeightElement = document.getElementById(
    "safe-area-top-height"
  );
  if (!safeAreaTopHeightElement) return 0;
  const style = window.getComputedStyle(safeAreaTopHeightElement);
  const safeAreaTopHeight = parseInt(style.height, 10);
  safeAreaTopHeightElement.remove();
  return safeAreaTopHeight;
};
